import * as types from './layout.actionType';

export default {
  setShowTooltip: data => ({
    type: types.SET_SHOWTOOLTIP,
    payload: data,
  })
};
